var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0333 1.77778L14.8169 9.52778C14.4562 10.0556 15.1498 10.6944 15.6493 10.25L20.7825 5.77778C20.9212 5.66667 21.1154 5.75 21.1154 5.94444V19.9167C21.1154 20.1111 20.8657 20.1944 20.7547 20.0556L5.21643 1.44444C4.71698 0.833333 3.99556 0.5 3.1909 0.5H2.63596C1.19312 0.5 0 1.69444 0 3.16667V22.8333C0 24.3056 1.19312 25.5 2.66371 25.5C3.57936 25.5 4.43951 25.0278 4.93896 24.2222L10.1554 16.4722C10.5161 15.9444 9.82242 15.3056 9.32297 15.75L4.18979 20.1944C4.05105 20.3056 3.85683 20.2222 3.85683 20.0278V6.08333C3.85683 5.88889 4.10655 5.80556 4.21754 5.94444L19.7558 24.5556C20.2553 25.1667 21.0044 25.5 21.7814 25.5H22.3363C23.8069 25.5 25 24.3056 25 22.8333V3.16667C25 1.69444 23.8069 0.5 22.3363 0.5C21.3929 0.5 20.5327 0.972222 20.0333 1.77778Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.cfdd1deaa546f11d9ed05f0af77ecc32.svg";
export { ForwardRef as ReactComponent };